<template>
  <v-card
    tile
    >
    <v-card-title>Images</v-card-title>

    <v-card-subtitle>Main Image</v-card-subtitle>
    <v-card-text>

      <!-- Main Image Form -->
      <v-row
        v-if="!mainImageExists()"
        align="center"
      >
        <v-col cols="5">
          <v-file-input
            accept="image/*"
            label="Upload Main Image"
            prepend-icon="mdi-camera"
            show-size
            :loading="mainImageloading"
            @change="setMainImage"
          >
          </v-file-input>
        </v-col>
        <v-col cols="2">
          <v-btn
            small
            dark
            :loading="mainImageloading"
            :disabled="mainUploadDisable"
            color="success"
            @click="uploadMainImage"
          >
          Upload
          <v-icon class="ml-2">
            mdi-cloud-upload
          </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <!-- Display Main Image -->
      <v-row>
        <v-col
          md="4"
          v-for="(image, mi) in adminAsset.images.filter(i => i.type === 'mainImage')"
          :key="mi"
          >
          <v-img 
            :src="image.mediumUri"
          >
            <v-chip
              small
              color="red"
              text-color="white"
              class="px-1 ma-1 float-right"
              @click="removeImage(image.id)"
            >
              <v-icon small dense>
                mdi-delete
              </v-icon>
            </v-chip>
          </v-img>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-subtitle>Gallery Images</v-card-subtitle>

    <v-card-text>
      <!-- Gallery Images Form -->
      <v-row
        align="center"
      >
        <v-col cols="5">
          <v-file-input
            v-model="galleryFormVal"
            accept="image/*"
            multiple
            label="Upload Gallery Images"
            prepend-icon="mdi-camera"
            show-size
            :loading="galleryImageloading"
            @change="setGalleryImages"
          >
          </v-file-input>
        </v-col>
        <v-col cols="2">
          <v-btn
            small
            dark
            color="success"
            :loading="galleryImageloading"
            :disabled="galleryUploadDisable"
            @click="uploadGalleryImages"
          >
          Upload
          <v-icon class="ml-2">
            mdi-cloud-upload
          </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <!-- Gallery Images Display -->
      <v-row>
        <v-col
          md="2"
          v-for="(image, i) in adminAsset.images.filter(i => i.type === 'galleryImage')"
          :key="i"
          >
          <v-img 
            :src="image.smallUri"
          >
            <v-chip
              small
              color="red"
              text-color="white"
              class="px-1 ma-1 float-right"
              @click="removeImage(image.id)"
            >
              <v-icon small dense>
                mdi-delete
              </v-icon>
            </v-chip>
          </v-img>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-btn
        v-if="this.$route.name !== 'flipItemEditImages'"
        @click="$emit('dialog-close')"
      >
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: "AssetImageForm",

    computed: {
      ...mapGetters([
        'adminAsset',
      ]),
    },

    data: () => ({
      // Main image upload data.
      mainImageloading: false,
      mainUploadDisable: true,
      mainImageErr: '',
      mainImageFile: {},

      // Gallery image upload data.
      galleryImageloading: false,
      galleryUploadDisable: true,
      galleryFormVal: null,
      galleryImageErr: '',
      galleryImageFiles: []

    }),

    methods: {
      ...mapActions([
        'deleteAssetImage',
        'attachAssetImage',
        'getAssetById'
      ]),

      // Is there a main image in the array?
      mainImageExists: function () {
        if (this.adminAsset.images !== undefined 
          && this.adminAsset.images.find(image => image.type === 'mainImage')
        ) {
          return true
        }
        return false
      },

      // Main image toggle helper.
      setMainImage: function (file) {
        if (file !== undefined) {
          this.mainImageFile = file
          this.mainUploadDisable = false
        }
        else {
          this.mainImageFile = {}
          this.mainUploadDisable = true
        }
      },

      // Gallery images toggle and set.
      setGalleryImages: function (files) {
        if (files.length > 0) {
          this.galleryImageFiles = files
          this.galleryUploadDisable = false
        }
        else {
          this.galleryImageFiles = []
          this.galleryUploadDisable = true
        }
      },

      // Upload images of type galleryImage, handling multiple images.
      uploadGalleryImages: function () {
        let uploadPromises = []
        this.galleryImageloading = true

        for (let i = 0; i < this.galleryImageFiles.length; i++) {
          // Collect a promise for each upload.
          uploadPromises.push(
            this.attachAssetImage({
              assetId: this.adminAsset.id,
              type: 'galleryImage',
              file: this.galleryImageFiles[i]
            })
            .catch(() => {
              console.error(`There was a problem uploading gallery image ${i}`)
            })
          )
        }

        // When all promises complete, do some cleanup.
        Promise.all(uploadPromises).then(() => {
          this.galleryImageloading = false
          this.galleryUploadDisable = true
          this.galleryImageFiles = []
          this.galleryFormVal = null

          // Reload the asset in state
          this.getAssetById(this.adminAsset.id)
        })
      },

      // Upload an image of type mainImage.
      uploadMainImage: function () {
        this.mainImageloading = true

        this.attachAssetImage({
          assetId: this.adminAsset.id,
          type: 'mainImage',
          file: this.mainImageFile
        })
        .then(() => {
          this.mainImageloading = false
        })
        .catch(() => {
          console.error('There was a problem uploading main image.')
        })
      },

      // Delete an image.
      removeImage: function (imageId) {
        this.deleteAssetImage({
          assetId: this.adminAsset.id,
          assetImageId: imageId
        })
        .then(() => {
          this.mainImageFile = {}
          this.mainUploadDisable = true
        })
      }
    }
  }
</script>
